/**
 * THE URL THIS SITE SERVES FOR A LOGICAL PATH — one definition, used by the
 * app's <SEO> canonical/hreflang and by scripts/generateSitemap.js.
 *
 * The build writes `build/pricing/index.html`, so S3+CloudFront answers 200 at
 * `https://stylon.co/pricing/` and 302 at `https://stylon.co/pricing`. When
 * canonical/hreflang/sitemap declared the no-slash form, they pointed at a
 * redirect that pointed back — Search Console on 2026-09-21 held 112 URLs as
 * "Alternate page with proper canonical tag" (every one the slash form of a
 * real page), 50 as "Page with redirect" and 27 as "Duplicate without
 * user-selected canonical". So a non-root path ends with "/", exactly as
 * served. CommonJS, because a build script and the browser bundle share it.
 */
const SITE_ORIGIN = 'https://stylon.co';
const DEFAULT_LANG = 'en';

/** `/pricing` + `he` → `https://stylon.co/he/pricing/`; `/` + `en` → `https://stylon.co/`. */
function siteUrlFor(logicalPath, lang, origin = SITE_ORIGIN) {
  const prefix = !lang || lang === DEFAULT_LANG ? '' : `/${lang}`;
  const raw = logicalPath == null ? '' : String(logicalPath);
  const tail = raw === '' || raw === '/' ? '/' : raw.endsWith('/') ? raw : `${raw}/`;
  return `${origin}${prefix}${tail}`;
}

module.exports = { siteUrlFor, SITE_ORIGIN_DEFAULT: SITE_ORIGIN };
